import React, { useEffect } from 'react';
import { AvisosPrivacidadJS } from '../../json/AvisosPrivacidadJS';
import '../AvisosPrivacidad/estilos.css';

  const AvisosPrivacidad = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
        <div className="row">
              <div className='ldf_titulo'> 
                  <h2 className="title">Avisos de Privacidad</h2>
                  <hr className="hr-gob" />
              </div>
            
            <div className="contenedor-tablaAvisos">
            <table className="table table-striped">
                    <tbody>
                       {
                        AvisosPrivacidadJS.map((item, index)=>(
                          <tr key={ index }>
                              <th><div className="detalle_iAP"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row">
                                <div className="detalle_documentoAP"> { item.nombre } </div>
                              </th>
                              <td>
                                <div>
                                    <a href={ item.linkAviso } target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div>
                              </td>
                          </tr>
                        ))
                       }
                  </tbody>
              </table>
          </div>         
       </div>
    </div>
    )
}

export default AvisosPrivacidad